import {
    faEdit,
    faExclamation,
    faFileExcel,
    faPlus,
    faSearch,
    faTrash,
    faChevronLeft,
    faChevronRight
} from "@fortawesome/free-solid-svg-icons";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useEffect, useState } from "react";
import { toast, ToastContainer } from "react-toastify";

import {
    getClientes,
    guardarCliente,
    actualizarCliente,
    eliminarCliente
} from "../../../services/clienteservice";

import XLSX from "xlsx-js-style";
import "../Cliente/Cliente.css";

export default function Cliente() {

    const userData = JSON.parse(localStorage.getItem("user"));

    const [modalNuevoOpen, setModalNuevoOpen] = useState(false);
    const [deleteModalOpen, setDeleteModalOpen] = useState(false);

    const [clientes, setClientes] = useState([]);
    const [busqueda, setBusqueda] = useState("");
    const [paginaActual, setPaginaActual] = useState(1);

    const itemPorPagina = 15;

    const [cliente, setCliente] = useState({
        idcliente: 0,
        nombre: "",
        apellido: "",
        razonsocial: "",
        documento: "",
        celular: "",
        direccion: "",
        correo: ""
    });

    /* =========================
        CARGAR CLIENTES
    ========================= */
    const cargarClientes = async () => {
        try {
            const data = await getClientes();

            if (!data) {
                toast.error("No hay clientes");
                return;
            }

            const normalizados = data.map(c => ({
                idcliente: c.idcliente,
                nombre: c.nombre,
                apellido: c.apellido,
                razonsocial: c.razonsocial,
                documento: c.documento,
                celular: c.celular,
                direccion: c.direccion,
                correo: c.correo
            }));

            setClientes(normalizados);

        } catch (error) {
            console.error(error);
            toast.error("Error de conexión");
        }
    };

    useEffect(() => {
        cargarClientes();
    }, []);

    /* =========================
        FILTRO
    ========================= */
    const clientesFiltrados = clientes.filter(item => {
        const t = busqueda.toLowerCase();

        return (
            item.idcliente.toString().includes(t) ||
            item.nombre.toLowerCase().includes(t) ||
            item.apellido.toLowerCase().includes(t) ||
            item.razonsocial.toLowerCase().includes(t) ||
            item.documento.toLowerCase().includes(t) ||
            item.celular.toLowerCase().includes(t)
        );
    });

    const indexUltimo = paginaActual * itemPorPagina;
    const indexPrimero = indexUltimo - itemPorPagina;

    const itemsActuales = clientesFiltrados.slice(indexPrimero, indexUltimo);

    const paginasTotales = Math.ceil(clientesFiltrados.length / itemPorPagina);

    const rangoPaginas = () => {

        let inicio = Math.max(1, paginaActual - 1);

        let fin = Math.min(paginasTotales, inicio + 2);

        if (fin - inicio < 2) {
            inicio = Math.max(1, fin - 2);
        }

        const paginas = [];

        for (let i = inicio; i <= fin; i++) {

            if (i > 0) paginas.push(i);

        }

        return paginas;
    };

    /* =========================
        CRUD
    ========================= */
    const handleSubmit = async (e) => {
        e.preventDefault();

        const datos = {
            ...cliente,
            idusuario: userData.idusuario
        };

        try {
            let result;

            if (cliente.idcliente === 0) {
                result = await guardarCliente(datos);
            } else {
                result = await actualizarCliente(datos);
            }

            if (result?.status === "success") {
                toast.success("Operación exitosa");
                setModalNuevoOpen(false);
                cargarClientes();
            } else {
                toast.error("Error en operación");
            }

        } catch (error) {
            console.error(error);
            toast.error("Error servidor");
        }
    };

    const handleEdit = (item) => {
        setCliente(item);
        setModalNuevoOpen(true);
    };

    const borrarCliente = async () => {
        try {
            const res = await eliminarCliente({
                ...cliente,
                idusuario: userData.idusuario
            });

            if (res?.status === "success") {
                toast.success("Cliente eliminado");
                setDeleteModalOpen(false);
                cargarClientes();
            } else {
                toast.error("Error al eliminar");
            }

        } catch (error) {
            console.error(error);
            toast.error("Error servidor");
        }
    };

    /* =========================
        EXCEL
    ========================= */
    const descargarExcel = () => {
        const data = clientes.map(c => ({
            ID: c.idcliente,
            Nombre: c.nombre,
            Apellido: c.apellido,
            "Razón Social": c.razonsocial,
            Documento: c.documento,
            Celular: c.celular,
            Dirección: c.direccion,
            Correo: c.correo
        }));

        const ws = XLSX.utils.json_to_sheet(data);
        const wb = XLSX.utils.book_new();

        XLSX.utils.book_append_sheet(wb, ws, "Clientes");
        XLSX.writeFile(wb, "clientes.xlsx");
    };

    return (
        <div className="main-content">

            <ToastContainer />

            {/* HEADER estilo Destino */}
            <div className="nuevo-container">

                <div className="search-wrapper">
                    <FontAwesomeIcon icon={faSearch} className="search-icon" />
                    <input
                        className="search-input"
                        placeholder="Buscar cliente..."
                        value={busqueda}
                        onChange={(e) => {
                            setBusqueda(e.target.value);
                            setPaginaActual(1);
                        }}
                    />
                </div>

                <div>
                    <button
                        className="nuevo"
                        onClick={() => {
                            setCliente({
                                idcliente: 0,
                                nombre: "",
                                apellido: "",
                                razonsocial: "",
                                documento: "",
                                celular: "",
                                direccion: "",
                                correo: ""
                            });
                            setModalNuevoOpen(true);
                        }}
                    >
                        <FontAwesomeIcon icon={faPlus} /> Nuevo Cliente
                    </button>
                </div>
            </div>

            {/* TABLE estilo Destino */}
            <div className="table-container">
                <table className="table">
                    <thead>
                        <tr>
                            <th>ID</th>
                            <th>Nombre</th>
                            <th>Apellido</th>
                            <th>Razón Social</th>
                            <th>Documento</th>
                            <th>Celular</th>
                            <th>Dirección</th>
                            <th>Correo</th>
                            <th>Acciones</th>
                        </tr>
                    </thead>

                    <tbody>
                        {itemsActuales.length > 0 ? (
                            itemsActuales.map(item => (
                                <tr key={item.idcliente}>
                                    <td>{item.idcliente}</td>
                                    <td>
                                        <span className="nombre-resaltado">
                                            {item.nombre}
                                        </span>
                                    </td>
                                    <td>{item.apellido}</td>
                                    <td className="col-razonsocial" title={item.razonsocial}>
                                        {item.razonsocial}
                                    </td>
                                    <td>{item.documento}</td>
                                    <td>{item.celular}</td>
                                    <td className="col-direccion" title={item.direccion}>
                                        {item.direccion}
                                    </td>
                                    <td>{item.correo}</td>

                                    <td style={{ textAlign: "center" }}>
                                        <button className="editar" onClick={() => handleEdit(item)}>
                                            <FontAwesomeIcon icon={faEdit} />
                                        </button>

                                        <button
                                            className="eliminar"
                                            onClick={() => {
                                                setCliente(item);
                                                setDeleteModalOpen(true);
                                            }}
                                        >
                                            <FontAwesomeIcon icon={faTrash} />
                                        </button>
                                    </td>
                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td colSpan="9" style={{ textAlign: "center", padding: "20px" }}>
                                    No hay clientes
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>
            <div className="pagination-container">

                <div className="pagination-info">
                    Página {paginaActual} de {paginasTotales || 1}
                </div>

                <div className="pagination-controls">

                    <button
                        className="pag-btn prev-next"
                        onClick={() =>
                            setPaginaActual(p => Math.max(p - 1, 1))
                        }
                        disabled={paginaActual === 1}
                    >
                        <FontAwesomeIcon icon={faChevronLeft} />
                    </button>

                    {rangoPaginas().map(num => (

                        <button
                            key={num}
                            className={`pag-btn number ${paginaActual === num ? "active" : ""
                                }`}
                            onClick={() => setPaginaActual(num)}
                        >
                            {num}
                        </button>

                    ))}

                    <button
                        className="pag-btn prev-next"
                        onClick={() =>
                            setPaginaActual(p =>
                                Math.min(p + 1, paginasTotales)
                            )
                        }
                        disabled={
                            paginaActual === paginasTotales ||
                            paginasTotales === 0
                        }
                    >
                        <FontAwesomeIcon icon={faChevronRight} />
                    </button>

                </div>

            </div>
            {/* MODAL FORM estilo Destino */}
            {modalNuevoOpen && (
                <div className="modalOverlay" onClick={() => setModalNuevoOpen(false)}>
                    <div className="modalWindow" onClick={(e) => e.stopPropagation()}>

                        <div className="modalHeader">
                            <h2>Cliente</h2>
                        </div>

                        <div className="modalBody">

                            <div className="modalRow">
                                <input className="input-modal" placeholder="Nombre"
                                    value={cliente.nombre}
                                    onChange={(e) => setCliente({ ...cliente, nombre: e.target.value })}
                                />

                                <input className="input-modal" placeholder="Apellido"
                                    value={cliente.apellido}
                                    onChange={(e) => setCliente({ ...cliente, apellido: e.target.value })}
                                />
                            </div>

                            <div className="modalRow">
                                <input className="input-modal" placeholder="Razón Social"
                                    value={cliente.razonsocial}
                                    onChange={(e) => setCliente({ ...cliente, razonsocial: e.target.value })}
                                />

                                <input className="input-modal" placeholder="Documento"
                                    value={cliente.documento}
                                    onChange={(e) => setCliente({ ...cliente, documento: e.target.value })}
                                />
                            </div>

                            <div className="modalRow">
                                <input className="input-modal" placeholder="Celular"
                                    value={cliente.celular}
                                    onChange={(e) => setCliente({ ...cliente, celular: e.target.value })}
                                />

                                <input className="input-modal" placeholder="Correo"
                                    value={cliente.correo}
                                    onChange={(e) => setCliente({ ...cliente, correo: e.target.value })}
                                />
                            </div>

                            <input className="input-modal" placeholder="Dirección"
                                value={cliente.direccion}
                                onChange={(e) => setCliente({ ...cliente, direccion: e.target.value })}
                            />

                        </div>

                        <div className="modalFooter">
                            <button className="modalBtn btnCancelar" onClick={() => setModalNuevoOpen(false)}>
                                Cancelar
                            </button>

                            <button className="modalBtn btnGuardar" onClick={handleSubmit}>
                                Guardar
                            </button>
                        </div>

                    </div>
                </div>
            )}

            {/* DELETE MODAL estilo Destino */}
            {deleteModalOpen && (
                <div className="modalOverlay" onClick={() => setDeleteModalOpen(false)}>
                    <div className="modalWindow deleteStyle" onClick={(e) => e.stopPropagation()}>

                        {/* HEADER */}
                        <div className="deleteHeader">
                            <button
                                onClick={() => setDeleteModalOpen(false)}
                                className="deleteCloseX"
                            >
                                ×
                            </button>
                        </div>

                        {/* ICON */}
                        <div className="deleteIconContainer">
                            <div className="deleteIconCircle">
                                <FontAwesomeIcon icon={faExclamation} />
                            </div>
                        </div>

                        {/* BODY */}
                        <div className="deleteBodyContent">

                            <h3 className="deleteTitle">¿Eliminar cliente?</h3>

                            <p className="deleteText">
                                El cliente{" "}
                                <b>
                                    {cliente?.nombre} {cliente?.apellido}
                                </b>{" "}
                                será eliminado permanentemente.
                            </p>

                            <div className="deleteActions">
                                <button
                                    className="btnCancelGhost"
                                    onClick={() => setDeleteModalOpen(false)}
                                >
                                    Cancelar
                                </button>

                                <button
                                    className="btnConfirmFilled"
                                    onClick={borrarCliente}
                                >
                                    Confirmar
                                </button>
                            </div>

                        </div>

                    </div>
                </div>
            )}

        </div>
    );
}